<template>
  <div class="md:hidden w-full h-full bg-white relative">
    <div class="flex flex-col p-6 justify-between border-t">
      <div class="flex justify-start">
        <div class="flex grow px-1.5 2xl:px-5 py-2 border border-slate-400 rounded-lg">
          <img :src="'/vectors/headers/headerDate.svg'" width="20px" height="20px" />
          <div class="my-auto pr-0 pl-2 lg:pr-1.5">
            <p class="font-semibold text-xs">{{ currentDateTime.format('dddd') }},</p>
            <p class="font-normal text-ss">{{ currentDateTime.format('D MMMM YYYY - HH:mm') }}</p>
          </div>
        </div>
        <!-- <div class="flex px-1.5 border border-slate-400 rounded-lg">
          <img
            :src="'/vectors/headers/headerNotification.svg'"
            width="20px"
            height="20px"
            class="mr-2"
          />
          <div class="my-auto px-1.5 py-1 bg-header-notification rounded-full">
            <p class="font-normal text-ss text-white">999</p>
          </div>
        </div> -->
      </div>
      <div class="flex mt-[16px] h-[52px]" @click="showUserMenu = !showUserMenu">
        <img
          :src="
            userProfile.getUserProfile.thumbnail
              ? img_url + userProfile.getUserProfile.thumbnail
              : '/img/default-avatar.png'
          "
          class="rounded-xl mr-4 w-[48px] h-[48px]"
        />
        <!-- <img :src="'/img/user-1.png'" class="rounded-xl mr-4 w-[52px]" /> -->
        <div class="grow">
          <div class="text-[16px] font-semibold">
            {{ userProfile.getUserProfile.fullname || '' }}
          </div>
          <div class="text-[12px]">{{ userProfile.getUserProfile.email || '' }}</div>
        </div>
        <button type="button">
          <img
            :src="'/vectors/headers/headerProfileDown.svg'"
            width="20px"
            height="20px"
            v-show="!showUserMenu"
          />
          <BaseIcon :icon-name="iconNames.UP" v-show="showUserMenu" />
        </button>
      </div>
      <div class="flex flex-col mt-[16px]" v-show="showUserMenu">
        <button
          class="flex flex-row items-center p-[8px] hover:bg-[--algo-brand-violet-100] rounded-[6px]"
          type="button"
          @click="() => router.push({ name: pageNames.USERPROFILE })"
        >
          <span class="grow text-left font-medium">My Account</span>
          <BaseIcon :icon-name="iconNames.USER" />
        </button>
        <button
          @click="router.push({ name: pageNames.LOGOUT })"
          class="flex flex-row items-center p-[8px] hover:bg-[--algo-brand-violet-100] rounded-[6px]"
        >
          <span class="grow text-left font-medium">Log Out</span>
          <BaseIcon :icon-name="iconNames.SIGNOUT" />
        </button>
      </div>
    </div>
    <div class="flex border-t"></div>
    <!-- <div class="border-t-[1px] border-slate-300"></div> -->
    <div class="py-8 px-[20px] border-slate-300 justify-start">
      <p class="text-tertiary font-semibold text-start text-sm">Main</p>
      <button
        :class="[currentRouteName === pageNames.HOME ? 'active' : '']"
        class="flex w-full mt-4 p-2 justify-start text-menubar text-base font-medium rounded-md menubar-list cursor-pointer"
        @click="() => router.push({ name: pageNames.HOME })"
      >
        <div
          :class="[
            currentRouteName === pageNames.HOME ? 'menubar-landing-active' : 'menubar-landing'
          ]"
          width="24px"
          height="24px"
        ></div>
        <p class="pl-3">Algo</p>
      </button>
      <button
        :class="[
          shrinked ? 'justify-center' : 'justify-start',
          currentRouteName === pageNames.RESEARCH ? 'active' : ''
        ]"
        class="flex w-full mt-4 p-2 justify-start text-menubar text-base font-medium rounded-md menubar-list cursor-pointer"
        @click="() => router.push({ name: pageNames.RESEARCH })"
      >
        <div
          :class="[
            currentRouteName === pageNames.RESEARCH ? 'menubar-research-active' : 'menubar-research'
          ]"
          width="24px"
          height="24px"
        ></div>
        <p class="pl-3">Content</p>
      </button>
      <button
        v-if="userProfile.getUserProfile.role === 'corporate'"
        :class="[
          shrinked ? 'justify-center' : 'justify-start',
          currentRouteName === pageNames.WRITER ? 'active' : ''
        ]"
        class="flex w-full mt-4 p-2 justify-start text-menubar text-base font-medium rounded-md menubar-list cursor-pointer"
        @click="() => router.push({ name: pageNames.WRITER })"
      >
        <div
          :class="[
            currentRouteName === pageNames.WRITER ? 'menubar-writer-active' : 'menubar-writer'
          ]"
          width="24px"
          height="24px"
        ></div>
        <p class="pl-3">Writer</p>
      </button>
    </div>
  </div>
</template>
<script setup lang="ts">
import BaseIcon from '@/components/base/baseIcon.vue'
import { iconNames } from '@/enums/iconNames'
import { pageNames } from '@/enums/pageNames'
import { userProfileStore } from '@/stores/user/userProfile'
import moment from 'moment'
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

const route = useRoute()
const router = useRouter()

const img_url = import.meta.env.VITE_IMG_URL

const shrinked = ref(false)
const currentDateTime = ref<moment.Moment>(moment())
const showUserMenu = ref(false)
const userProfile = userProfileStore()
const currentRouteName = computed(() => route.name)
setInterval(() => {
  currentDateTime.value = moment()
}, 1000)
</script>
